import React from 'react';
import useTheme from 'branding/theme';
import useComponentMargin from '../../hooks/useComponentMargin';
import Label from '../../typography/Label';
import AlertIcon from '../../icons/utility/AlertIcon';
import InputError from '../InputError';
import withFocus from '../../hocs/withFocus';
import withFormErrors from '../../hocs/withFormErrors';
import { withFormProps } from '../../hocs/withFormProps/withFormProps';
import mergeFocusHandlers from '../../utils/mergeFocusHandlers';
export const Input = React.forwardRef(({ name, defaultValue, displayName, type = 'text', placeholder = '', required = false, size = 'large', disabled = false, centerLabel = false, showErrMessage = true, readOnly = false, isError = false, isFocused, handleBlur, handleFocus, onBlur, errorId, errorMessage, styles, wrapperStyles, maxLength, autoCapitalize, autoComplete, autoCorrect, spellCheck, ...rest }, ref) => {
    const isQty = type === 'qty';
    const isDateTime = type === 'date' || type === 'month' || type === 'time';
    const showError = !!errorId || isError;
    const focusHandlers = mergeFocusHandlers({ handleBlur, handleFocus, onBlur });
    const { borders, sizing, inputs: { base, shape, size: sizeStyles, disabled: disabledInputStyles, utilityIconStyles }, utility: { size: { fullWidthStyles } } } = useTheme();
    const marginStyles = useComponentMargin({
        marginVertical: 'small',
        ...((!showErrMessage || !errorMessage) && { marginBottom: 'regular' })
    });
    const mergedStyles = {
        ...base,
        ...shape.pill,
        ...sizeStyles.regular,
        ...fullWidthStyles,
        ...(disabled && disabledInputStyles),
        ...(!isFocused && borders.variant.secondary),
        // error styles MUST come after active styles to override them
        ...(showError && {
            ...borders.error,
            paddingRight: `calc(${base.paddingRight} * 2.5)` // make room for the icon
        }),
        ...(isDateTime && { height: '5.2rem' }),
        ...marginStyles,
        ...styles
    };
    const mergedWrapperStyles = {
        width: sizing.widths.input[size],
        position: 'relative',
        ...wrapperStyles
    };
    const alertIconStyle = {
        ...utilityIconStyles,
        ...(isDateTime && { right: '6rem', top: '4.4rem' }),
        ...(!displayName && { top: '2rem' })
    };
    return (React.createElement("div", { style: mergedWrapperStyles },
        displayName && (React.createElement(Label, { htmlFor: name, required: required, disabled: disabled, centered: !!centerLabel }, displayName)),
        React.createElement("input", { maxLength: maxLength, defaultValue: defaultValue, placeholder: placeholder, type: isQty ? 'text' : type, name: name, id: name, required: required, disabled: disabled, style: mergedStyles, "aria-invalid": !!errorId, "aria-describedby": errorId, readOnly: readOnly, "aria-readonly": readOnly, ref: ref, autoCapitalize: autoCapitalize, autoComplete: autoComplete, autoCorrect: autoCorrect, spellCheck: spellCheck, ...rest, ...focusHandlers }),
        !isQty && showError && React.createElement(AlertIcon, { size: "utility", styles: alertIconStyle }),
        showErrMessage && errorMessage && (React.createElement(InputError, { id: errorId }, errorMessage))));
});
export default withFormErrors(withFormProps(withFocus(Input)));
//# sourceMappingURL=index.js.map